import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ILookUpType, UtilitiesService } from 'lib-core-shared';

@Component({
  selector: 'app-product-master-status',
  templateUrl: './product-master-status.component.html',
  styleUrls: ['./product-master-status.component.scss']
})
export class ProductMasterStatusPillComponent implements OnInit {
  @Input() masterProductStatus!: ILookUpType;
  @Input() supersessions!: any[];
  @Input() parentComponent?: string;

  constructor(
    private router: Router,
    public utilitiesService: UtilitiesService,
    public activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {}

  navigateTo(id: number) {
    if (id) {
      // if the component is in the product-result-container then we can load the S product exactly the same as we would load any other product from this page
      if (this.parentComponent && this.parentComponent === 'product-result-container') {
        this.router.navigate([`/products/details/${id}/core`]);
      } else {
        // in other instances we dont specify a parentComponent from the parent and in this case we first route to the redirect-to component, which is an empty
        // page with a loading spinner then route to the products detail page - this forces the page to refresh.
        this.router.navigateByUrl('/products/redirect-to').then(() => {
          this.router.navigate([`/products/details/${id}/core`]);
        })
      }
    }
  }
}
